import { useConsent, setConsent } from '../analytics';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SoftButton, PrimaryButton } from './touchable';

export default function ConsentBanner() {
  const consent = useConsent();
  const { t } = useTranslation('settings');
  if (consent !== 'pending') return null;
  return (
    <div
      role="region"
      aria-label={t('analytics.banner.aria', 'Analytics consent')}
      className="fixed bottom-0 left-0 right-0 z-50 flex flex-col gap-2 border-t border-line bg-card p-4 shadow-lg"
    >
      <p className="text-sm text-ink">
        <Trans
          i18nKey="analytics.banner.body"
          ns="settings"
          defaults="knittime sends anonymous usage and crash data to help improve the app. You can change this anytime in Settings. See our <privacyLink>privacy policy</privacyLink> for what we collect."
          components={{
            privacyLink: <Link to="/learn/privacy/" className="text-primary underline" />,
          }}
        />
      </p>
      <div className="flex justify-end gap-2">
        <SoftButton
          onClick={() => setConsent('declined')}
          className="w-auto px-4 py-2 text-sm"
        >
          {t('analytics.banner.decline', 'Decline')}
        </SoftButton>
        <PrimaryButton
          onClick={() => setConsent('granted')}
          className="w-auto px-4 py-2 text-sm"
        >
          {t('analytics.banner.allow', 'Allow')}
        </PrimaryButton>
      </div>
    </div>
  );
}
